import React, { JSX } from 'react';
import BusinessKitzLogo from '../../../assets/svg/business-kitz-logo.svg?react';
import { Grid } from '@mui/material';
import AuthFooter from '../auth-footer/AuthFooter';
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

interface AuthTemplateProps extends React.PropsWithChildren {
  featureItems?: JSX.Element;
}

const AuthTemplate = ({ featureItems, children }: AuthTemplateProps) => {
  const { isSignedIn } = useUser();
  if (isSignedIn) {
    return <Navigate to={ROUTES.HOME} />;
  }
  return (
    <div className='demo-auth-template'>
      <header>
        <Grid component='div' container>
          <Grid
            id='authTemplateOpenExternalLink'
            component='div'
            size={{ xs: 12 }}
            className='demo-auth-template-logo-item'
            sx={{
              '&:hover': {
                cursor: 'pointer',
              },
            }}
            onClick={() => window.open('https://www.businesskitz.com', '_blank')}
          >
            <BusinessKitzLogo id='authTemplateOpenExternalLinkBusinessKitzLogo' />
          </Grid>
        </Grid>
      </header>
      <Grid
        component='div'
        container
        className='demo-auth-template-container'
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        {featureItems && (
          <Grid component='div' size={{ xs: 12, sm: 6, md: 6, lg: 4 }} sx={{ p: 3 }}>
            {featureItems}
          </Grid>
        )}
        <Grid
          component='div'
          size={{ xs: 12, sm: 6, md: 6, lg: 4 }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            //minHeight: '60vh',
          }}
        >
          {children}
        </Grid>
      </Grid>
      <AuthFooter />
    </div>
  );
};

export default AuthTemplate;
